import { Card } from "@/components/ui/card";

interface TocItem {
  id: string;
  label: string;
}

interface DocTocProps {
  items: TocItem[];
}

export function DocToc({ items }: DocTocProps) {
  return (
    <Card className="mb-12 border border-border bg-card p-6">
      <h3 className="mb-4 text-sm font-bold text-foreground">Contents</h3>
      <ul className="grid list-none grid-cols-1 gap-2 pl-0 sm:grid-cols-2 sm:gap-x-8 sm:gap-y-2">
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className="text-sm text-muted-foreground transition-colors hover:text-primary"
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </Card>
  );
}
